import React from "react";

import { Col, Form } from "react-bootstrap";

import classNames from "classnames";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

import styles from "./FromSwitchOption.module.scss";

interface FromSwitchOptionProps<TFieldValues extends FieldValues, TKey> {
  fieldName: Path<TFieldValues>;
  control: Control<TFieldValues>;
  switchId: string;
  label: string;
  description?: string;
  toggleSwitch: (switchKey: TKey) => void;
  switchStates: TKey[];
  switchKey: TKey;
}

const FromSwitchOption = <TFieldValues extends FieldValues, TKey>({
  fieldName,
  control,
  switchId,
  label,
  description,
  toggleSwitch,
  switchStates,
  switchKey,
}: FromSwitchOptionProps<TFieldValues, TKey>) => {
  const isSelected = Array.isArray(switchStates)
    ? switchStates.includes(switchKey)
    : Object.values(switchStates).includes(switchKey);
  return (
    <Col className="d-flex justify-content-center">
      <div className={`${styles["card-desktop"]} ${isSelected ? styles["selected-option"] : ""}`}>
        <div className={styles["text"]}>
          <h4>{label}</h4>
          {description && <div className={classNames(styles["sub-text"], "b4")}>{description}</div>}
        </div>
        <Controller
          name={fieldName}
          control={control}
          render={() => (
            <Form.Switch
              className={styles["form-switch"]}
              type="switch"
              id={switchId}
              checked={isSelected}
              onChange={() => toggleSwitch(switchKey)}
            />
          )}
        />
      </div>
    </Col>
  );
};

export default FromSwitchOption;
